import React,{Component} from "react";
import {
  WithStyles,
  withStyles,
  Card,
  CardContent,
  Box,
  FormLabel,
  Typography,
  IconButton,
  Modal,
  Backdrop,
  Fade
} from "@material-ui/core";
import { ListaGestionGuialStyles } from "../../styles";
import { IGuia } from "../../interface";
import { connect } from "react-redux";
import { soporteAdicional } from '../../repository/ChatDao';
import CloseIcon from "@material-ui/icons/Close";
import { Confirmacion } from './Confirmacion';
import { finalizarChatEndPoint} from '../../repository/FinalizarDao';

interface ListaGestionGuiaState {
  open: boolean;
  terminar: boolean;
  soporte: boolean;
  soporteSolicitado: boolean;
  terminado: boolean;
  asesorAsignado: boolean;
}
interface ListaGestionGuiaProp
  extends WithStyles<typeof ListaGestionGuialStyles> {
  guia: IGuia;
  handleCerrar: () => void;
  children?: React.ReactNode;
  className?: string;
}

export class ListaGestionGuiaComponent extends Component<ListaGestionGuiaProp, ListaGestionGuiaState> {

  constructor(props:ListaGestionGuiaProp) {
    super(props);
    this.state = {
      open: false,
      terminar: false,
      soporte: false,
      soporteSolicitado: false,
      terminado: false,
      asesorAsignado: false
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpenFinalizar = this.handleOpenFinalizar.bind(this);
    this.handCloseCerrarConfirmar = this.handCloseCerrarConfirmar.bind(this);
    this.handleFinalizar = this.handleFinalizar.bind(this);
    this.handleSoporteAdicional = this.handleSoporteAdicional.bind(this);
    this.handleOpenSoporteAdicional = this.handleOpenSoporteAdicional.bind(this);
  }

  handleOpenSoporteAdicional(){
    console.log(this.props.guia);


    if(this.props.guia.estado === 'FINALIZADO'){
      this.setState({
        terminado: true
      })
    }else if(this.props.guia.soporte_adicional === true || this.props.guia.causal === '701' ){
      this.setState({
        soporteSolicitado:true
     })

    } else if(this.props.guia.nombre_asesor){
      this.setState({
        asesorAsignado:true
     })

    }else{
      this.setState({
        soporte:true
      })
    }

}

  handleOpen(){
    this.setState({
      open:true
    })
  }

  handleClose() {
    this.props.handleCerrar();
    this.setState({
      open:false
    })
  }

  handleOpenFinalizar() {
    this.setState({
      terminar:true
    })
  }

  handleSoporteAdicional(){
    soporteAdicional(this.props.guia).then()
    this.setState({
      soporte:false
    })
  }

  handCloseCerrarConfirmar() {
    this.props.handleCerrar();
    this.setState({
      terminar:false,
      soporte:false,
      soporteSolicitado:false
    })
  }

  handleFinalizar() {
    this.props.handleCerrar();
    //finalizarChat(this.props.guia.guia);
    finalizarChatEndPoint(this.props.guia).then();
    this.setState({
      terminar:false
    })
  }
  
  render(){
    const classes = this.props.classes;
    return (
      <div>
        <div id="modal">
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={this.state.open}
            onClose={this.handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={this.state.open}>
              <div className={classes.paper}>

                <Card className={classes.paper}>
                  <CardContent>
                    <Box maxWidth="lg">
                    <Box display="flex" justifyContent="space-between" alignItems="center" >
                        <FormLabel className={classes.detalle}>
                          <Typography className={classes.headertitulo}>
                           Empleado(s) encargado(s)
                          </Typography>
                        </FormLabel>
                        <Box>
                          <IconButton className={classes.iconpadding} onClick={this.handleClose}>
                            <CloseIcon />
                          </IconButton>
                        </Box>
                        
                    </Box>
                      {
                        (!this.props.guia.nombre_empleado || this.props.guia.nombre_empleado === '') ? 

                        ''
                        
                        : 
                        <Box>
                        <FormLabel className={classes.datos}>
                          Repartidor:
                        </FormLabel>
                        <FormLabel  className={classes.repartidor}>
                          {' '+this.props.guia.nombre_empleado} 
                        </FormLabel>
                      </Box>

                      }
                     
                      {
                        (!this.props.guia.nombre_asesor || this.props.guia.nombre_asesor === '') ? 

                        ''
                        
                        : 
                        <Box>
                        <FormLabel className={classes.datos}>
                          Asesor:  
                        </FormLabel>
                        <FormLabel className={classes.datos}>
                          {' '+this.props.guia.nombre_asesor}
                        </FormLabel>
                       </Box>
                      }
                      <Box paddingTop={2}>
                        <FormLabel className={classes.detalle}>
                          <Typography className={classes.headertitulo}>
                            Detalle del envío
                          </Typography>
                        </FormLabel>
                      </Box>
                      <Box>
                        <FormLabel className={classes.detalle}>
                          Fecha del envío:
                        </FormLabel>
                        <FormLabel className={classes.detalle}>
                          {this.props.guia.fecha_envio}
                        </FormLabel>
                      </Box>
  
                      <Box>
                        <FormLabel>
                          <Typography className={classes.titulo}>
                            Remitente
                          </Typography>
                        </FormLabel>
                      </Box>
  
                      <Box>
                        <FormLabel className={classes.datos}>
                          {this.props.guia.nombre_remitente}
                        </FormLabel>
                      </Box>
  
                      <Box>
                        <FormLabel className={classes.datos}>
                          {this.props.guia.direccion_remitente}
                        </FormLabel>
                      </Box>
  
                      <Box>
                        <FormLabel className={classes.datos}>
                          Tel: {this.props.guia.telefono_remitente}
                        </FormLabel>
                      </Box>
  
                      <Box>
                        <FormLabel>
                          {" "}
                          <Typography className={classes.titulo}>
                            Destinatario
                          </Typography>
                        </FormLabel>
                      </Box>
  
                      <Box>
                        <FormLabel className={classes.datos}>
                          {this.props.guia.nombre_destinatario}
                        </FormLabel>
                      </Box>
  
                      <Box>
                        <FormLabel className={classes.datos}>
                          {this.props.guia.direccion_destinatario}
                        </FormLabel>
                      </Box>
                      <Box>
                        <FormLabel className={classes.datos}>
                          Tel: {this.props.guia.telefono_destinatario}
                        </FormLabel>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </div>
  
            </Fade>
          </Modal>
        </div>
        <Box>
            <div id="close" className={classes.dropdown}>
              <div className={classes.dropdownContent}>
                <ul className={classes.ul}>
                  <li className={classes.li} onClick={() => this.handleOpen()}>
                    {" "}
                    Detalle del envío
                  </li>
                  <li className={classes.li} onClick={() => this.handleOpenSoporteAdicional()}>
                    {" "}
                    Solicitar soporte adicional
                  </li>
                  {this.props.guia.estado === "NO-FINALIZADO" && (
                    <li
                      className={classes.li}
                      onClick={() => this.handleOpenFinalizar()}
                    >
                      {" "}
                      Finalizar chat
                    </li>
                  )}
                </ul>
              </div>
            </div>    
            <Confirmacion id='dialog' 
          open={this.state.terminar} 
          titulo='Finalizar Chat' 
          texto='¿Esta seguro que desea finalizar la conversación?'
          callbackCerrar={this.handleClose}
          callbackCerrarConfirm={this.handCloseCerrarConfirmar}
          callbackAceptarConfirm={this.handleFinalizar}
          bottonAceptar={true}
          />
          <Confirmacion id='dialog2' 
          open={this.state.soporte} 
          titulo='Solicitar Soporte Adicional' 
          texto='¿Esta seguro que desea solicitar soporte adicional?'
          callbackCerrar={this.handleClose}
          callbackCerrarConfirm={this.handCloseCerrarConfirmar}
          callbackAceptarConfirm={this.handleSoporteAdicional}
          bottonAceptar={true}
          />
          <Confirmacion id='dialog3' 
          open={this.state.soporteSolicitado} 
          titulo='' 
          texto='Ya se ha solicitado soporte adicional'
          callbackCerrar={this.handleClose}
          callbackCerrarConfirm={this.handCloseCerrarConfirmar}
          bottonAceptar={false}
          bottonAceptarCancelar={true}
          />
          <Confirmacion id='dialog4' 
          open={this.state.terminado} 
          titulo='Chat Finalizado' 
          texto='Actualmente el chat se encuentra finalizado'
          callbackCerrar={this.handleClose}
          callbackCerrarConfirm={this.handCloseCerrarConfirmar}
          bottonAceptar={false}
          />
          <Confirmacion id='dialog5' 
          open={this.state.asesorAsignado} 
          titulo='' 
          texto='La guía tiene un asesor de servicio al cliente asignado'
          callbackCerrar={this.handleClose}
          callbackCerrarConfirm={this.handCloseCerrarConfirmar}
          bottonAceptar={false}
          bottonAceptarCancelar={true}
          />
        </Box>
      </div>
    );
  }

}

const mapStateToProps = (state: any) => {
  return {
    guia: state.guiasReducer,
  };
};

const mapDispatchToProps = () => ({});

export const ListaGestionGuia = withStyles(ListaGestionGuialStyles)(
  connect(mapStateToProps, mapDispatchToProps)(ListaGestionGuiaComponent)
);
